import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-voucher-notification-dialog',
  templateUrl: './voucher-notification-dialog.component.html',
  styleUrls: ['./voucher-notification-dialog.component.scss']
})
export class VoucherNotificationDialogComponent {

  constructor(public dialogRef: MatDialogRef<VoucherNotificationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }
}
